export const Login = {
	title: "Login",
	description: "Unlock the hydraulic platform of the future.",
	button_text: "Login",
	button_text_loading: "Logging in...",
	error_message: "Login failed. Please try again later.",
	forgot_password_link_text: "Forgot password?",
	microsoft_sso_button_text: "Sign in with Microsoft",
};
